// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"658":"febc20b4","891":"01fa697b"}[chunkId] + ".chunk.js";
};